// extracted by mini-css-extract-plugin
module.exports = {"yearSelector":"_2cArd","yearSelect":"_2XL58","spinner":"_2_wyk","spinnerAnimation":"_2dzOg","yearSelectorTitle":"_36EWJ"};